import React, { useEffect, useState, useCallback } from 'react';
import { api } from '../context/AuthContext';

// Panel kecil untuk 4 cron job Sybase ASE. Sengaja TIDAK menyediakan editor
// ekspresi cron: jadwalnya dikirim balik apa adanya saat toggle, supaya
// '*/5 * * * *' dan '0 3 1 * *' tidak tertimpa jadi "harian jam sekian".
const PREFIX = 'ase_';

export default function AseJobsPanel() {
  const [jobs, setJobs] = useState(null);
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState('');
  const [msg, setMsg] = useState('');

  const load = useCallback(() => {
    api.get('/api/cron')
      .then((r) => {
        const raw = Array.isArray(r.data) ? r.data : (r.data.jobs || r.data.items || []);
        setJobs(raw.filter((j) => String(j.key || '').indexOf(PREFIX) === 0));
      })
      .catch((e) => setErr((e && e.response && e.response.data && e.response.data.error) || String(e.message || e)));
  }, []);

  useEffect(() => { load(); }, [load]);

  const toggle = (j) => {
    setBusy(j.key); setMsg('');
    api.put('/api/cron/' + j.key, { enabled: !j.enabled, schedule: j.schedule })
      .then(() => { setMsg((j.enabled ? 'Disabled ' : 'Enabled ') + j.key); load(); })
      .catch((e) => setMsg('Gagal: ' + ((e && e.response && e.response.data && e.response.data.error) || e.message)))
      .finally(() => setBusy(''));
  };

  const runNow = (j) => {
    setBusy(j.key); setMsg('Menjalankan ' + j.key + '...');
    api.post('/api/cron/' + j.key + '/run', {})
      .then((r) => setMsg(j.key + ' -> ' + JSON.stringify(r.data).slice(0, 300)))
      .catch((e) => setMsg('Gagal: ' + ((e && e.response && e.response.data && e.response.data.error) || e.message)))
      .finally(() => { setBusy(''); load(); });
  };

  const btn = (bg) => ({ padding: '4px 10px', borderRadius: 8, border: '1px solid #cbd5e1', background: bg || 'transparent', color: 'inherit', fontSize: 12, cursor: 'pointer' });

  if (err) return <div style={{ fontSize: 12.5, color: '#dc2626' }}>{err}</div>;
  if (!jobs) return <div style={{ fontSize: 12.5, color: '#94a3b8' }}>loading jobs...</div>;
  if (!jobs.length) return <div style={{ fontSize: 12.5, color: '#94a3b8' }}>No ASE jobs registered.</div>;

  return (
    <div style={{ marginTop: 16 }}>
      <div style={{ fontSize: 12.5, fontWeight: 600, marginBottom: 6 }}>ASE monitoring jobs</div>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12.5 }}>
        <tbody>
          {jobs.map((j) => (
            <tr key={j.key} style={{ borderTop: '1px solid #e2e8f0' }}>
              <td style={{ padding: '6px 10px', fontFamily: 'monospace' }}>{j.key}</td>
              <td style={{ padding: '6px 10px', color: '#64748b' }}>{j.label || ''}</td>
              <td style={{ padding: '6px 10px', fontFamily: 'monospace', color: '#64748b' }}>{j.schedule}</td>
              <td style={{ padding: '6px 10px', fontWeight: 600, color: j.enabled ? '#047857' : '#94a3b8' }}>
                {j.enabled ? 'ON' : 'OFF'}
              </td>
              <td style={{ padding: '6px 10px', textAlign: 'right', whiteSpace: 'nowrap' }}>
                <button style={btn()} disabled={busy === j.key} onClick={() => toggle(j)}>
                  {j.enabled ? 'Disable' : 'Enable'}
                </button>
                {' '}
                <button style={btn()} disabled={busy === j.key} onClick={() => runNow(j)}>Run now</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {msg && <div style={{ fontSize: 12, color: '#64748b', marginTop: 8, wordBreak: 'break-all' }}>{msg}</div>}
    </div>
  );
}
